import { OfferData, dailyBonusBadgeProps } from '@/lib/types';

import { Observable } from './observable';

class PopupStateService {
  readonly popupOffers = new Observable<OfferData[]>([]);
  readonly currentPopupDisplayed = new Observable<OfferData | null>(null);
  readonly dailyBonusBadgesNextDate = new Observable<Date | null>();
  readonly dailyBonusBadges = new Observable<dailyBonusBadgeProps[]>([]);
  readonly rewardCalendarBadgesNextDate = new Observable<Date | null>();
  readonly rewardCalendarBadges = new Observable<dailyBonusBadgeProps[]>([]);
  readonly triggeredPopupBadges = new Observable<dailyBonusBadgeProps[]>([]);
  readonly popupIndexToCollect = new Observable<number>(0);
  readonly popUpStartHourUTC = new Observable<number>(0);
  readonly showFailPopup = new Observable<boolean>(false);
  readonly isRewardCalendarExiting = new Observable<boolean>(false);

  clear = () => {
    this.popupOffers.set([]);
    this.currentPopupDisplayed.set(null);
    this.dailyBonusBadgesNextDate.set(null);
    this.dailyBonusBadges.set([]);
    this.rewardCalendarBadgesNextDate.set(null);
    this.rewardCalendarBadges.set([]);
    this.triggeredPopupBadges.set([]);
    this.popupIndexToCollect.set(0);
    this.popUpStartHourUTC.set(0);
    this.showFailPopup.set(false);
    this.isRewardCalendarExiting.set(false);
  };

  setPopupOffers = (offers: OfferData[]) => this.popupOffers.set(offers);
  setCurrentPopupDisplayed = (current: OfferData | null) => this.currentPopupDisplayed.set(current);
  setDailyBonusBadgesNextDate = (next: Date | null) => this.dailyBonusBadgesNextDate.set(next);
  setDailyBonusBadges = (badges: dailyBonusBadgeProps[]) => this.dailyBonusBadges.set(badges);
  setRewardCalendarBadgesNextDate = (next: Date | null) =>
    this.rewardCalendarBadgesNextDate.set(next);
  setRewardCalendarBadges = (badges: dailyBonusBadgeProps[]) =>
    this.rewardCalendarBadges.set(badges);
  setTriggeredPopupBadges = (badges: dailyBonusBadgeProps[]) =>
    this.triggeredPopupBadges.set(badges);
  setPopupIndexToCollect = (index: number) => this.popupIndexToCollect.set(index);
  setPopUpStartHourUTC = (hour: number) => this.popUpStartHourUTC.set(hour);
  setShowFailPopup = (show: boolean) => this.showFailPopup.set(show);
  setIsRewardCalendarExiting = (value: boolean) => this.isRewardCalendarExiting.set(value);
}

export const popupStateService = new PopupStateService();
